import React from 'react';

interface ContainerProps {
    children: React.ReactNode[] | React.ReactNode;
}

export default function Container({ children }: ContainerProps) {
    return (
        <div className="container h-[calc(var(--app-height)-80px)] w-full overflow-y-auto overflow-x-auto px-6 py-3">
            {children}
        </div>
    );
}
